import _ from 'underscore';

export function updateOdataOptionsForCriterionType(options) {
  const optionsCopy = options || { custom: {} };

  _.extendOwn(optionsCopy.custom, {
    Criterion: {
      isof: value => `isof(Criterion, ${value})`,
    },
  });

  return optionsCopy;
}

export function updateOdataOptionsForDayTimeCriterionDay(options) {
  const optionsCopy = options || { custom: {} };

  _.extendOwn(optionsCopy.custom, {
    'Criterion/DayTimeCriterion/Day': {
      eq: (value) => {
        const enmu = value.replace('Enum.CriterionDayTimeCriterionDay', 'Enum.Day');
        return `Criterion/Model.DayTimeCriterion/Day eq ${enmu}`;
      },
    },
  });

  return optionsCopy;
}

export function updateOdataOptionsForDeviceCriterionDeviceName(options) {
  const optionsCopy = options || { custom: {} };

  _.extendOwn(optionsCopy.custom, {
    'Criterion/DeviceCriterion/DeviceName': {
      eq: (value) => {
        const enmu = value.replace('Enum.CriterionDeviceCriterionDeviceName', '');
        return `Criterion/Model.DeviceCriterion/DeviceName eq ${enmu}`;
      },
    },
  });

  return optionsCopy;
}
